/* Programme A/B (11/10/2026), test « email » : capture d'e-mail −10 % de bienvenue.
 * Balisage et textes : sections/email-popup-klaviyo.liquid (rendu seulement si un test de zone « email » est actif).
 * Version lue sur <html data-v-email> : aucun | popup | mousse | bandeau.
 *  - popup, mousse : affichage au premier de « 15 s » ou « 50 % de défilement », jamais avant 8 s, jamais sur /cart ni le
 *    checkout, jamais tiroir ouvert (html.m6pn-open) ; une fois par visiteur (fermé = plus rien pendant 7 jours).
 *  - bandeau : visible tout de suite, posé au-dessus de la barre d'achat collante de la fiche (#rp-sticky.rp-visible).
 *  - code déjà obtenu (ici ou dans le tiroir, version « remise » : localStorage rs_remise_email) : plus aucune capture.
 * E-mail valide → Klaviyo (API client, clé publique ; sautée si la clé est vide) → code appliqué au panier
 * (/cart/update.js { discount }) → tiroir re-rendu.
 */
(function () {
  var H = document.documentElement, V = H.getAttribute('data-v-email') || '';
  var cfgEl = document.getElementById('rsm-cfg');
  if (!cfgEl || !/^(popup|mousse|bandeau)$/.test(V)) return;
  var C = {}; try { C = JSON.parse(cfgEl.textContent) || {}; } catch (e) { return; }
  var CODE = C.code || 'BIENVENUE10';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  // Navigateur forcé sur la zone e-mail (?cro_t=email:X, aperçu interne) : on ignore la mémoire (code obtenu, fermé, déjà vu)
  // pour pouvoir revoir la version à chaque fois. Les vrais visiteurs gardent les règles normales.
  var FORCE = false; try { FORCE = !!(JSON.parse(localStorage.getItem('cro_tf') || '{}') || {}).email; } catch (e) {}
  if (!FORCE && (ls('rs_remise_email') === '1' || ls('rs_mail_code') === '1')) return;
  if (/^\/(?:[a-z]{2}(?:-[a-z]+)?\/)?(cart|checkouts?)(\/|$)/.test(location.pathname)) return;
  var ferme = +(ls('rs_mail_ferme') || 0);
  if (!FORCE && ferme && Date.now() - ferme < 7 * 864e5) return;

  var carte = document.querySelector('[data-rsm="' + V + '"]'), voile = document.querySelector('[data-rsm-voile]');
  if (!carte) return;
  var reduit = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fermer() {
    carte.hidden = true; if (voile) voile.hidden = true;
    H.classList.remove('rsm-ouvert');
    ls('rs_mail_ferme', String(Date.now()));
  }
  function montrer() {
    if (V !== 'bandeau' && voile) voile.hidden = false;
    carte.hidden = false;
    if (V !== 'bandeau') H.classList.add('rsm-ouvert');
    ls('rs_mail_vu', String(Date.now()));
    if (V === 'mousse') mousse();
  }

  /* ── Déclenchement ── */
  if (V === 'bandeau') {
    var poser = function () {
      var s = document.getElementById('rp-sticky');
      var h = s && s.classList.contains('rp-visible') && !H.classList.contains('m6pn-open') ? s.offsetHeight : 0;
      // Aperçu du thème : la barre de prévisualisation Shopify (en bas) recouvrirait le bandeau.
      var pb = document.getElementById('PBarNextFrameWrapper'); if (pb && pb.offsetHeight) h += pb.offsetHeight;
      carte.style.setProperty('--rsm-bas', h + 'px');
    };
    var att = 0, plusTard = function () { if (!att) att = requestAnimationFrame(function () { att = 0; poser(); }); };
    window.addEventListener('scroll', plusTard, { passive: true });
    window.addEventListener('resize', plusTard);
    var s0 = document.getElementById('rp-sticky');
    if (s0) new MutationObserver(plusTard).observe(s0, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function () { carte.style.visibility = H.classList.contains('m6pn-open') ? 'hidden' : ''; plusTard(); }).observe(H, { attributes: true, attributeFilter: ['class'] });
    poser(); montrer();
  } else {
    if (ls('rs_mail_vu') && !FORCE) return; // une seule fois par visiteur
    var t0 = Date.now(), fait = false;
    var essayer = function () {
      if (fait) return;
      var dt = Date.now() - t0, sh = document.documentElement.scrollHeight - innerHeight;
      var defile = sh > 0 && scrollY / sh >= 0.5;
      if (dt < 8000 || !(dt >= 15000 || defile)) return;
      if (H.classList.contains('m6pn-open') || H.classList.contains('m2a') || document.visibilityState !== 'visible') return;
      fait = true; clearInterval(tic); window.removeEventListener('scroll', essayer); montrer();
    };
    var tic = setInterval(essayer, 1000);
    window.addEventListener('scroll', essayer, { passive: true });
  }

  /* ── C : mousse au doigt (assets/rs-mousse.js, chargé à l'ouverture de la carte) ── */
  function mousse() {
    var go = function () { if (window.rsMousse) window.rsMousse(carte, { evt: evt, code: CODE }); };
    if (window.rsMousse) { go(); return; }
    if (!C.mousse_js) return;
    var sc = document.createElement('script'); sc.src = C.mousse_js; sc.onload = go; document.head.appendChild(sc);
  }

  /* Événement du suivi CRO : un clic sur un élément data-cro est capté par cro-tracker.js. */
  function evt(nom) { try { var m = document.createElement('i'); m.hidden = true; m.setAttribute('data-cro', nom); m.setAttribute('data-cro-label', V); document.body.appendChild(m); m.click(); m.remove(); } catch (e) {} }

  /* ── Envoi de l'e-mail ── */
  // Code posé sur le panier (cart/update.js) ET dans le cookie de remise Shopify (/discount/CODE) : la capture arrive souvent
  // avant tout ajout, et un panier encore vide ne garde pas toujours le code ; le cookie le réapplique au panier suivant.
  function appliquer() {
    var maj = function () { return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: CODE }) }).catch(function () {}); };
    return fetch('/discount/' + encodeURIComponent(CODE), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {})
      .then(maj).then(function () { if (window.rsAB && rsAB.rafraichir) rsAB.rafraichir(); }, function () {});
  }
  // Après un ajout au panier, si le code a été obtenu, on le repose (le panier peut avoir été recréé entre-temps).
  document.addEventListener('rsm:reappliquer', function () { if (ls('rs_mail_code') === '1') appliquer(); });
  function klaviyo(email) {
    if (!C.cle || !C.liste) return Promise.resolve('sans-cle'); // préparation : clé publique pas encore connue
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(C.cle), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: (C.source || 'Capture site') + ' · ' + V,
        profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { list: { data: { type: 'list', id: C.liste } } } } })
    }).then(function (r) { if (r.status !== 202) throw new Error('klaviyo ' + r.status); return 'ok'; });
  }
  function envoyer(zone) {
    var champ = zone.querySelector('[data-rsm-email]'), btn = zone.querySelector('[data-rsm-envoyer]'), err = zone.querySelector('[data-rsm-err]');
    var email = (champ && champ.value || '').trim();
    err.hidden = true;
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) { err.textContent = C.err || 'E-mail invalide'; err.hidden = false; if (champ) champ.focus(); return; }
    btn.disabled = true;
    klaviyo(email).then(function () {
      ls('rs_mail_code', '1'); ls('rs_remise_email', '1');
      var f = zone.querySelector('[data-rsm-form]'), ok = zone.querySelector('[data-rsm-ok]');
      if (f) f.hidden = true; if (ok) ok.hidden = false;
      try { carte.dispatchEvent(new Event('rsm:inscrit')); } catch (x) {}
      evt('email_inscrit');
      return appliquer();
    }).catch(function () { btn.disabled = false; err.textContent = C.err_envoi || 'Réessayez'; err.hidden = false; });
  }

  carte.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-rsm-fermer]')) { fermer(); return; }
    if (t.closest('[data-rsm-ouvrir]')) {
      var corps = carte.querySelector('[data-rsm-corps]'), o = corps.hidden;
      corps.hidden = !o; carte.classList.toggle('is-ouvert', o); t.closest('[data-rsm-ouvrir]').setAttribute('aria-expanded', String(o));
      if (o) { var c = corps.querySelector('[data-rsm-email]'); if (c) c.focus(); }
      return;
    }
    if (t.closest('[data-rsm-envoyer]')) { envoyer(t.closest('[data-rsm-envoyer]').closest('[data-rsm-form]').parentNode); return; }
    if (t.closest('[data-rsm-copier]')) {
      var b = t.closest('[data-rsm-copier]');
      if (navigator.clipboard) navigator.clipboard.writeText(CODE).then(function () { b.textContent = '✓'; }, function () {});
    }
  });
  carte.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-rsm-email]')) { e.preventDefault(); envoyer(e.target.closest('[data-rsm-form]').parentNode); }
    if (e.key === 'Escape' && V !== 'bandeau') fermer();
  });
  if (voile) voile.addEventListener('click', fermer);
})();
